import { render, staticRenderFns } from "./SsPriceInput.vue?vue&type=template&id=4197a2df&"
import script from "./SsPriceInput.vue?vue&type=script&lang=js&"
export * from "./SsPriceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports